import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const ContextAttributes = ({context}) => {
  return (
    <Fragment>
      <ul>
        <li>Tracked on: {context.createDate}</li>
        <li>Context ID: {context.contextId}</li>
        <li>Context Title: {context.contextTitle}</li>
        <li>Canvas Course PK: {context.canvasCourseId}</li>
        <li>
          Instructor Email:{' '}
          <a
            href={`/account/support_dashboard/-/${context.instructorId}/`}
          >
            {context.instructor}
          </a>
        </li>
        <li>
          Go To Setup:{' '}
          <a
            href={`/links/canvas_connect.instructor_setup/-/${context.id}/?instructor_id=${context.instructorId}`}
          >
            Setup Context
          </a>
        </li>
      </ul>
    </Fragment>
  )
}

ContextAttributes.propTypes = {
  context: PropTypes.object.isRequired,
}

export default ContextAttributes
